module.exports = __webpack_public_path__ + "img/qrcode_frame.427c8594.svg";